/* eslint-disable prettier/prettier */
import * as React from 'react';
import { FallbackProps } from 'react-error-boundary';
import ErrorMessage from './ErrorMessage';

export const FallbackUI = ({ error }: FallbackProps) => {
  return (
    <ErrorMessage
      error={error}
      title={error.name}
      description={error.message}
    />
  );
};
